import * as React from 'react';

export interface IVideoPlaceholderImageProps {
    src: string;
    alt: string;
}

export default function VideoPlaceholderImage({ src, alt }: IVideoPlaceholderImageProps) {
    return (
        <div className="fa-video-placeholder-image">
            <div className="fa-video-overlay-effect" />
            <figure aria-hidden="true">
                {src && <img src={src} alt={alt} height="100%" width="100%" />}
                <div className="fa-video-placeholder-image__button">
                    <div className="fa-video-play-button fa-js--video-play-button">
                        <span className="fa-video-play-button__icon"></span>
                    </div>
                </div>
            </figure>
        </div>
    );
}
